export const getEdgeCodeVersion = (v) => {
    if (v === null || v === undefined || v === '--') return 0;
    const sanitizedVersion = v.replace(/v/gi, '');
    const versionSplit = sanitizedVersion.split('.');

    const major = Number(versionSplit[0] || 0);
    const minor = Number(versionSplit[1] || 0);
    const patch = Number(versionSplit[2] || 0);

    return Number(`${major}${String(minor).padStart(2, '0')}${String(patch).padStart(2, '0')}`);
}
